import {useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {PageHeader, TabsComponent} from '@/components/molecules'
import InventoryList from './InventoryList/InventoryList'

/**
 * Fulfillment component that manages warehouse and inventory management interface.
 * Includes tabbed content display.
 *
 * @returns {JSX.Element} The rendered fulfillment page component.
 */
export const Fulfillment = () => {
  const [params] = useSearchParams()
  const tab = params.get('tab') ? parseInt(params.get('tab')) : 0
  const [activeTabIndex, setActiveTabIndex] = useState(tab)

  /**
   * Tab config for toggling between "Warehouses" and "Inventory"
   */
  const tabList = [
    // {
    //   id: 'Warehouses',
    //   tabLabel: 'Warehouses',
    //   title: 'Warehouses',
    //   tabComponent: <WarehouseList />,
    // },
    {
      id: 'Inventory',
      tabLabel: 'Inventory',
      title: 'Inventory',
      tabComponent: <InventoryList />,
    },
  ]

  return (
    <div className="fullfillmentContainer flex flex-col">
      <PageHeader title="Fullfillment" />
      <TabsComponent tabList={tabList} defaultTabIndex={activeTabIndex} onTabChange={setActiveTabIndex} />
    </div>
  )
}
